import { Permissions } from '../constants';
/**
 * Guard function for validating if the current user role has access to a target route.
 * @param userRole
 * @param routePermissions
 * @returns {boolean|*}
 */
export function canAccessPath(userRole, routePermissions) {
  // on public paths we have an empty list of permissions which means we should allow everyone to access the path
  if (!routePermissions?.length) {
    return true;
  }

  const permissions = Permissions[userRole];

  return routePermissions.every((rp) => {
    const group = permissions[rp.group];
    if (!group) {
      return false;
    }

    // if no specific level is specified in route permissions, only having a permission group is enough
    // to allow user to navigate to a target route
    if (!rp.level) {
      return true;
    }

    return group[rp.level];
  });
}

export default null;
